export enum KnmReasonTypeNameEnum {
  IMPOSSIBILITY_OF_PREVIOUS = 'Невозможность проведения предыдущей проверки',
  PRESCRIPTION_CHECK = 'Проверка предписания',
  RISK_INDICATORS = 'Индикаторы риска',
  CHECKING_PROGRAM = 'Программа проверок',
  PV_INSTEAD_OF_KNM = 'Профилактический визит вместо КНМ',
  IMMEDIATE_CONTROL_PURCHASE = 'Незамедлительная контрольная закупка',
}
